import { render, staticRenderFns } from "./barAccountfc.vue?vue&type=template&id=1289e9cd"
import script from "./barAccountfc.vue?vue&type=script&lang=js"
export * from "./barAccountfc.vue?vue&type=script&lang=js"
import style0 from "./barAccountfc.vue?vue&type=style&index=0&id=1289e9cd&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports